module.exports = __webpack_public_path__ + "media/images/lb/326-2ea77d8c272b4f23a17c656f9d0c9785.svg";